import { render, staticRenderFns } from "./ServiceLaundryCustomerReports.vue?vue&type=template&id=2c02b686&scoped=true"
import script from "./ServiceLaundryCustomerReports.vue?vue&type=script&lang=js"
export * from "./ServiceLaundryCustomerReports.vue?vue&type=script&lang=js"
import style0 from "./ServiceLaundryCustomerReports.vue?vue&type=style&index=0&id=2c02b686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02b686",
  null
  
)

export default component.exports